export default "__VITE_ASSET__603414c6__"